import { Field, Form, Formik } from 'formik';
import { InputType } from '../../../Common/FormFields/InputType';
import { Button, Typography } from '@material-ui/core';
import Box from '@mui/material/Box';
import RoundButton from '../../../Common/RoundButton';
import ErrorMessage from '../../../Common/ErrorMessage';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
export default function FaqForm({
  initialValues,
  validationSchema,
  onSubmitHandle,
  onChangeField,
  handleUploadFile,
  enterKeyPress,
  formikRef,
}: any) {
  const { ticketResponseError } = useSelector((state: any) => state.ticket);

  return (
    <>
      <Box className='cardHeadingNew'>
        <Typography variant='h1'>message</Typography>
      </Box>

      <div className='faqHelp'>
        <Box className='addMoney'>
          <Box className='faqHelpBox'>
            <Formik
              validateOnMount={true}
              innerRef={formikRef}
              enableReinitialize={true}
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(value) => onSubmitHandle(value)}
            >
              {({ handleSubmit, values, touched, errors }) => (
                <Form>
                  <div>
                    {/* <Field
                    component={InputType}
                    type='text'
                    placeholder='enter first name'
                    name='firstName'
                    value={values?.firstName}
                    onChange={onChangeField}
                    className='withIcon userIcon'
                  />
                  <Field
                    component={InputType}
                    type='text'
                    placeholder='E-mail ID'
                    name='emailId'
                    value={values?.emailId}
                    onChange={onChangeField}
                    className='withIcon emailIcon'
                  />
                  <Field
                    component={InputType}
                    type='number'
                    placeholder='mobile no'
                    name='mobileNo'
                    value={values?.mobileNo}
                    onChange={onChangeField}
                    maxLength={10}
                    className='withIcon mobileIconBlue'
                  /> */}
                    <Field
                      component={InputType}
                      type='text'
                      placeholder='Type your message here'
                      name='message'
                      value={values?.message}
                      onChange={onChangeField}
                      multiline={true}
                      onKeyPress={enterKeyPress}
                    />
                  </div>
                  {ticketResponseError?.error?.errors ? (
                    <ErrorMessage
                      text={ticketResponseError?.error?.errors?.detail}
                    />
                  ) : (
                    ''
                  )}
                  <div>
                    <div className='msgButotnBox'>
                      <label className='custom-file-upload'>
                        <input type='file' onChange={handleUploadFile} />
                        upload file
                      </label>
                      <Button
                        className='btnBlue small no-shadow'
                        variant='contained'
                        type='submit'
                      >
                        submit form
                      </Button>
                      {/* <RoundButton type='submit' title={'submit form'} /> */}
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </Box>
        </Box>
      </div>
    </>
  );
}
